// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../common/Components/Loader.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let MySharedPostsWidgetList = require("./MySharedPostsWidgetList.bs.js");

function MySharedPostsWidgetRelay(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("h2", {
          children: "My Shared Posts",
          className: "text-gray-700 text-2xl font-medium"
        }),
        className: "flex gap-4 items-center flex-row mb-4"
      }),
      JsxRuntime.jsx(React.Suspense, {
        children: JsxRuntime.jsx(MySharedPostsWidgetList.make, {
          query: props.query,
          viewMoreMode: props.viewMoreMode
        }),
        fallback: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loader.make, {
            loadingText: "Loading shared posts..."
          }),
          className: "h-[340px] flex items-center justify-center"
        })
      })
    ],
    className: "bg-white p-5 rounded shadow-sm"
  });
}

let make = MySharedPostsWidgetRelay;

exports.make = make;
/* react Not a pure module */
